import api from './api';

export interface BulkInvoiceMeta {
  companies: { id: number; name: string }[];
  default_services: { id: number; name: string; identifier: string | null }[];
  payment_periods: { value: string; label: string }[];
}

export interface BulkInvoiceSelection {
  company_ids: number[];
  service_ids: number[];
  rel_type_values: string[];
  send_email?: boolean;
}

export interface BulkInvoicePreview {
  transaction_count: number;
  company_count: number;
  agreement_count: number;
}

export interface BulkInvoiceExecuteResult {
  created: number;
  failed: number;
  errors: string[];
  transaction_ids: number[];
}

export const bulkInvoicesApi = {
  async getMeta(): Promise<BulkInvoiceMeta> {
    const { data } = await api.get<BulkInvoiceMeta>('/api/bulk-invoice-generation/meta');
    return data;
  },

  async preview(body: BulkInvoiceSelection): Promise<BulkInvoicePreview> {
    const { data } = await api.post<BulkInvoicePreview>(
      '/api/bulk-invoice-generation/preview',
      body
    );
    return data;
  },

  async execute(body: BulkInvoiceSelection): Promise<BulkInvoiceExecuteResult> {
    const { data } = await api.post<BulkInvoiceExecuteResult>(
      '/api/bulk-invoice-generation/execute',
      body
    );
    return data;
  },
};
